export enum EIdTagsForAPIs {
  TEMPLATE = 'TEMPLATE',
}
